export default __webpack_public_path__ + "static/media/empty-folder-gray.dc8b7ede.svg";